import { Link } from '@remix-run/react';
import { useState } from 'react';

import ProfileIcon from '~/assets/icons/Profile';
import Tracked from '~/components/Tracked';
import useEnv from '~/hooks/useEnv';
import useUser from '~/hooks/useUser';
import type { TrackedButtonClickName } from '~/services/gtm.client';

import Menu from '../header/Menu';
import Icon from '../Icon';
import MenuModal from '../mobile-header';
import menus from './menus';
import Search from './Search';

export default function InternationalHeader() {
  const env = useEnv();

  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);

  return (
    <header className="main-header sticky top-0" role="banner">
      <div className="main-header__content">
        <section className="main-header__container">
          <Link to="/" className="main-header__logo-link">
            <Icon
              name="sole-icon"
              width="50"
              height="50"
              viewBox="0 0 58 44"
              fill="#FFFFFF"
              className="main-header__logo"
            />
          </Link>
          {env.FF_INTERNATIONAL_HEADERS && (
            <>
              <div className="flex w-full flex-row justify-between lg:hidden">
                <MenuModal
                  menu={menus.mobile}
                  mobileMenuIsOpen={mobileMenuIsOpen}
                  setMobileMenuIsOpen={setMobileMenuIsOpen}
                />
              </div>
              <div className="mr-4 flex items-center gap-4 lg:hidden">
                <Search.Mobile />
                <ProfileLink />
              </div>
              <div className="hidden w-full items-center justify-between lg:flex">
                <div>
                  <Menu menu={menus.desktop} />
                </div>
                <div className="flex items-center gap-4">
                  <Search.SearchForm />
                  <ProfileLink />
                </div>
              </div>
            </>
          )}
        </section>
      </div>
    </header>
  );
}

function ProfileLink() {
  const user = useUser();

  return (
    <Tracked.InternalLink
      pagePosition="Header"
      name={'Sign in' as TrackedButtonClickName}
      variant="none"
      to="/profile/"
    >
      <ProfileIcon color={user.isLoggedIn ? '#56BD6F' : '#A9A9A9'} />
    </Tracked.InternalLink>
  );
}
